/**
 * Created by saeed on 2/5/2017.
 */
import { Injectable }     from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {TranslateService} from 'ng2-translate';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {MatSnackBar,MatSnackBarConfig} from '@angular/material';
import {Direct} from "../../../../node_modules/protractor/built/driverProviders/direct";
import {AlertService} from "../alert/alert.service";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {SharingFormComponent} from "../../component/shared/sharing-form/sharing-form.component";


@Injectable()
export class SharingService {

  constructor(private translate:TranslateService, public dialog:MatDialog, public snackBar:MatSnackBar, private alertService:AlertService) {


  }

  copyToClipboard(text) {
    this.openSharingDialog(text);
  }

  public openSharingDialog(text):void {
    let dialogRef = this.dialog.open(SharingFormComponent, {
      width: '500px',
      data: {textToCopy: text}
    });
    dialogRef.afterClosed().subscribe(result => {


    });
  }


}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/sharing/sharing.service.ts